// NOTICE: The block below is autogenerated by platform/tools/sync-permissions
// BEGIN PERMISSIONS
export type Permission = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
 | 11 | 12 | 13 | 14 | 16 | 17 | 18 | 19 | 20 | 21
 | 22 | 23 | 24 | 26 | 27 | 28 | 29 | 30 | 31 | 32
 | 33 | 34 | 35 | 36 | 37 | 38 | 39 | 40 | 41 | 42
 | 43 | 44 | 45 | 46 | 47 | 48 | 49 | 50 | 51 | 52
 | 53 | 54 | 1001 | 1002 | 1003 | 1004 | 1005 | 1006 | 1007 | 1008
 | 1009 | 1010 | 1011 | 1012 | 1013 | 1014 | 1015 | 1016 | 1017 | 1018
 | 1019 | 1020 | 1021 | 1022 | 1023 | 1024 | 1025 | 2001 | 2002 | 2003
 | 2004 | 2005 | 2006 | 2007 | 2008 | 2009 | 3001 | 3002 | 3003;

export const adminRead: Permission = 1;
export const adminSalaries: Permission = 2;
export const adminCustomerExpenses: Permission = 3;
export const adminExpenses: Permission = 4;
export const adminOfferLetters: Permission = 5;
export const adminContractors: Permission = 6;
export const adminCandidates: Permission = 7;
export const adminCustomers: Permission = 8;
export const adminCustomerPositions: Permission = 9;
export const adminCustomerPositionsPipeline: Permission = 10;
export const adminDeposits: Permission = 11;
export const adminContractorInvoices: Permission = 12;
export const adminCustomerInvoices: Permission = 13;
export const adminInvoiceLines: Permission = 14;
export const adminEquipment: Permission = 16;
export const adminBackoffice: Permission = 17;
export const adminReferrals: Permission = 18;
export const adminUsers: Permission = 19;
export const adminUploadFiles: Permission = 20;
export const adminUploadPictures: Permission = 21;
export const adminWebhooks: Permission = 22;
export const adminTags: Permission = 23;
export const adminRevenue: Permission = 24;
export const adminExport: Permission = 26;
export const adminEditPositions: Permission = 27;
export const adminTalentLeads: Permission = 28;
export const adminLoginAs: Permission = 29;
export const adminExpenseCustomer: Permission = 30;
export const adminCandidatesInterviewed: Permission = 31;
export const adminUsersDelete: Permission = 32;
export const adminTasks: Permission = 33;
export const adminCandidatesCreated: Permission = 34;
export const adminTalentLeadsAdd: Permission = 35;
export const adminApplicantsAdd: Permission = 36;
export const adminBankAccounts: Permission = 37;
export const adminCandidatesChange: Permission = 38;
export const adminHolidays: Permission = 39;
export const adminCheckIns: Permission = 40;
export const adminRecordings: Permission = 41;
export const adminMessages: Permission = 42;
export const adminUserTFAReset: Permission = 43;
export const adminOnboarding: Permission = 44;
export const adminElevenlabsCalls: Permission = 45;
export const adminCandidateIM: Permission = 46;
export const adminIMTemplates: Permission = 47;
export const adminIMTemplatesEdit: Permission = 48;
export const adminBulkIM: Permission = 49;
export const adminBackgroundChecks: Permission = 50;
export const adminApprovals: Permission = 51;
export const adminCustomerTalentPreferences: Permission = 52;
export const adminBankAccountApprovals: Permission = 53;
export const adminCountryChangeApprovals: Permission = 54;
export const customerView: Permission = 1001;
export const customerContractors: Permission = 1002;
export const customerInvoices: Permission = 1003;
export const customerExpenses: Permission = 1004;
export const customerTimeOff: Permission = 1005;
export const customerTimeOffPolicies: Permission = 1006;
export const customerCompanyView: Permission = 1007;
export const customerCompanyEdit: Permission = 1008;
export const customerCompanyBenefits: Permission = 1009;
export const customerEquipment: Permission = 1010;
export const customerEquipmentApprove: Permission = 1011;
export const customerDocuments: Permission = 1012;
export const customerRefer: Permission = 1013;
export const customerPositions: Permission = 1014;
export const customerPositionsEdit: Permission = 1015;
export const customerPositionsEditFull: Permission = 1016;
export const customerPositionsPipeline: Permission = 1017;
export const customerPositionsVetting: Permission = 1018;
export const customerOfferLetters: Permission = 1019;
export const customerAllContractors: Permission = 1020;
export const customerCompanyUsers: Permission = 1021;
export const customerCompanyUsersEdit: Permission = 1022;
export const customerCompanyGroups: Permission = 1023;
export const customerCompanyGroupsEdit: Permission = 1024;
export const customerDeposits: Permission = 1025;
export const changeOwnEmail: Permission = 2001;
export const seeCandidateProfileLink: Permission = 2002;
export const seeCandidateSalaryExpectations: Permission = 2003;
export const watchRecording: Permission = 2004;
export const changeProfileComplete: Permission = 2005;
export const decreaseContractorSalary: Permission = 2006;
export const createOfferLetters: Permission = 2007;
export const listContractingEntities: Permission = 2008;
export const expandJobOpenings: Permission = 2009;
export const adminBankAccountsChange: Permission = 3001;
export const adminBankAccountsSeeRaw: Permission = 3002;
export const adminPayInvoices: Permission = 3003;
// END PERMISSIONS
